import React from 'react'
import HowParticipate from '../howParticipate/howParticipate'
import KitNosotras from '../kitNosotras/kitNosotras'
import WaysToParticipate from '../waysToParticipate/waysToParticipate.'
import AreYouTeacher from '../areYouTeacher/areYouTeacher'
import ThemesActivity from '../themesActivity/themesActivity'
import AreYouReady from '../areYouReady/areYouReady'
import SolveYourDoubts from '../solveYourDoubts/solveYourDoubts'
import EmotiveMessage from '../emotiveMessage/emotiveMessage'

const ContentHome = ({isLogged}) => {
  return (
    <>
      <EmotiveMessage isLogged={isLogged} />
      <HowParticipate isLogged={isLogged}/>
      <KitNosotras isLogged={isLogged}/>
      <WaysToParticipate isLogged={isLogged}/>
      <AreYouTeacher isLogged={isLogged}/>
      <ThemesActivity isLogged={isLogged}/>
      <AreYouReady isLogged={isLogged}/>
      <SolveYourDoubts isLogged={isLogged}/>
    </>
  )
}

export default ContentHome
